import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sdk } from '@/services';

const UserOnboardingService = sdk.getService('UserOnboardingService');

export const useMutateUserContract = () => {
  const queryClient = useQueryClient();
  const onSuccess = (userId?: string) => {
    queryClient.invalidateQueries({ queryKey: ['profile'] });
    queryClient.invalidateQueries({ queryKey: ['user-onboarding'] });
    if (userId) {
      queryClient.invalidateQueries({ queryKey: ['students', userId] });
    }
  };

  const { mutate: generateUserContract, isPending: isGenerating } = useMutation({
    mutationFn: () => UserOnboardingService.generateContract(),
    onSuccess: () => onSuccess()
  });

  const { mutate: removeUserContract, isPending: isRemoving } = useMutation({
    mutationFn: (userId: string) => UserOnboardingService.removeContract(userId),
    onSuccess: (_, userId) => onSuccess(userId)
  });

  return {
    isWorking: isGenerating || isRemoving,
    generateUserContract,
    removeUserContract
  };
};
